import { Component, OnInit, OnDestroy } from "@angular/core"
import { ActivatedRoute } from "@angular/router"

import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { Client } from "src/app/services/API/client"
import { LocaleConverterService } from "src/app/common/helpers/locale-converter.service"

interface Message {
  identification: number
  profileId: number
  type: string
  subject: string
  body: string
  bankingUser: string
  sentTime: string
  readTime: string
  isRead: boolean
}

@Component({
  templateUrl: "./message-detail.component.html",
  styleUrls: ["./message-detail.component.css"]
})

export class MessageDetailComponent implements OnInit, OnDestroy {
  loading: boolean = false
  paramsSubscription: any
  messageId: string = ""
  message: Message

  constructor(
    public toastr: toastrService, 
    private session: SessionService,
    private api: Client,
    private route: ActivatedRoute,
    private converter: LocaleConverterService
  ) {}

  ngOnInit() {
    this.paramsSubscription = this.route.params.subscribe((params) => {
      this.messageId = params["messageId"];
      this.getMessage();
    });
  }

  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }

  async getMessage() {
    if (!this.session.isLoggedIn() || !this.messageId) return

    this.loading = true
    try {
      const data = await this.api.get(`api/message/getMessageById?id=${this.messageId}`) as Message
      this.message = data
    } catch(err) {
      this.toastr.error(err.message)
    }
    this.loading = false
  }
}